export const JOB_POSTINGS_DOMAIN_NAME = 'jobPostings';
export const IMAGES_DOMAIN_NAME = 'images';
export const BLOG_POSTS_DOMAIN_NAME = 'blogPosts';
export const JOB_APPLICATIONS_DOMAIN_NAME = 'jobApplications';
export const MESSAGES_DOMAIN_NAME = 'messages';
